<script>
import TablePage from '@/found/components/table_page';
import Modal from '@/found/components/modal';
import Form from '../form';

export default {
  extends: TablePage,
  name: 'main_list',
  components: {
    Modal,
    Form,
  },
  data() {
    return {
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: '',
      },
    };
  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    // 按钮点击事件
    modalClick({ val, row }) {
      console.log({ val, row });
      console.log('this.formConfig', this.formConfig);

      if (['add', 'edit', 'view'].includes(val.code)) {
        this.formConfig = {};
        this.formName = 'Form';
        if (val.code === 'view') {
          this.modalConfig.title = '查看';
        } else if (val.code === 'edit') {
          this.modalConfig.title = '编辑';
        } else {
          this.modalConfig.title = '新增';
        }
        this.modalConfig.width = '70%';
        this.modalConfig.height = '600px';
        this.formConfig = {
          type: val.code,
          id: row.id || '',
          code: val.code || '',
        };
        this.openFull();
      }
    },
  },
};
</script>
